import React from 'react'
import cn from 'classnames'
import { timeAgo } from 'util/date'
import SanitizedHTML from 'shared/components/ui/SanitizedHTML'
import { textForEvent } from 'ducks/chat/utils/events'
import styles from './styles.less'

export default function StateEvent({ mxEvent, agentsByChatId, teamsById }) {
  const { id: stateId } = mxEvent.getContent()
  return (
    <div
      className={cn(styles['groove-event-state'], styles[`state-${stateId}`])}
    >
      <SanitizedHTML
        className={styles.details}
        html={`${textForEvent(mxEvent, { agentsByChatId, teamsById })}`}
      />
      <div className={styles.time}>{timeAgo(mxEvent.getDate())}</div>
    </div>
  )
}
